// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iO","input":"iP","button":"iQ"};